<template>
  <div class="pic_slide">
    <el-carousel arel-row="hover" :autoplay="false" height="390px">
<!--      <el-carousel-item class="pic_0">-->
<!--        <img :src="require('@/assets/pcimages/slide_text_5.png')" data-aos-once="true"   aos-anchor-placement="center-center" />-->
<!--      </el-carousel-item>-->

      <el-carousel-item class="pic_1">
        <el-row type="flex" justify="center" align="middle">

          <el-col :span="12">
            <p>奥云OCR系统</p>
            <span data-aos-once="true"   data-aos-easing="ease" data-aos-delay="600">支持蒙古文白体、黑体、标题体、新闻 体和哈旺体出版的图书、报纸、网络图 像和PDF文件的识别。</span>
            <a data-aos-once="true"   data-aos-easing="ease" data-aos-delay="800" href="http://ocr.mglip.com/user_login.action" target="_blank">试用</a>
          </el-col>

          <el-col :span="12">

            <img :src="require('@/assets/pcimages/slide_1_2.png')" data-aos-once="true"  data-aos="fade-down-left" data-aos-easing="ease" />

            <img :src="require('@/assets/pcimages/slide_1_1.png')" data-aos-once="true"  data-aos="fade-up-right" data-aos-easing="ease" />

          </el-col>

        </el-row>

      </el-carousel-item>

      <el-carousel-item class="pic_2">

        <div>

          <img :src="require('@/assets/pcimages/slide_text_1.png')" data-aos-once="true"  data-aos="flip-left" data-aos-delay="100" aos-anchor=".pic_1" aos-anchor-placement="center-center" />

          <div class="divider">
            <span></span>
            <div data-aos-once="true"  data-aos="flip-left" data-aos-delay="100" data-aos-anchor=".pic_1">多语言信息处理和相关技术研发</div>
            <span></span>
          </div>

        </div>

      </el-carousel-item>

      <el-carousel-item class="pic_3">

        <div>

          <p>奥云多语言开放平台为用户提供多语言信息处理相关高效的服务接口，共同推进多语言信息化进程。平台拥有多种多语言处理服务、专业技术支持，提供技术文档，节省开发成本。</p>

        </div>

      </el-carousel-item>

      <el-carousel-item class="pic_4">
        <el-row type="flex" justify="center" align="middle">

          <el-col :span="12">
            <img :src="require('@/assets/pcimages/slide_4_pic.png')" data-aos="fade-up" data-aos-easing="ease" />

          </el-col>
          <el-col :span="12">
            <p>支持蒙古文手写识别和<br />蒙古语语音识别功能的智能输入法</p>
            <span  data-aos="fade-up" data-aos-easing="ease" data-aos-delay="600">
              <ul>
                <li>手写识别输入</li><li>语音识别输入</li><li>词组联想输入</li>
                <li>智能模糊输入</li><li>智能推荐输入</li><li>智能扩展输入</li>
              </ul>
            </span>
            <a  data-aos-easing="ease" data-aos-delay="800" href="download.html"><img :src="require('@/assets/pcimages/dowmload_btn.png')"/></a>
          </el-col>
        </el-row>
      </el-carousel-item>
<!--      <el-carousel-item class="pic_6">-->
<!--        <el-row type="flex" justify="center" align="middle">-->
<!--          <el-col>-->
<!--            <div class="l_row">-->
<!--              <div><p>奥云大模型 </p><span>（公测版） </span></div>-->
<!--              <div class="mn">ᠣᠶᠤᠨ <br>ᠲᠣᠮᠣ᠌ <br>ᠵᠠᠭᠪᠤᠷ</div></div>-->
<!--            <div class="l_row subtitle">基于蒙古文语料训练的大语言模型</div>-->
<!--            <el-button type="primary" @click="toOyunChat">立即体验</el-button>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </el-carousel-item>-->
    </el-carousel>

  </div>
</template>
<script>
export default {
  methods:{
    toOyunChat(){
      window.open('https://chat.nmgoyun.com/','_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.pic_1{
  background: url('../../assets/pcimages/slide_bg_1.png')no-repeat top;
  .el-row--flex{
    background: url('../../assets/pcimages/slide_bg_1_1.png') no-repeat 80%;

  }
}
.pic_slide .pic_3 {
  background: url('../../assets/pcimages/slide_bg_3.png')no-repeat top;
}

.pic_slide .pic_4 {
  background: url('../../assets/pcimages/slide_bg_4.png')no-repeat top;
}
.pic_slide .pic_2 {
  background: url('../../assets/pcimages/slide_bg_2.png')no-repeat top;
}
.pic_slide .pic_6 {
  background: url('../../assets/pcimages/offclSlider5.png')no-repeat top;
}
.pic_slide .pic_6{
  padding: 75px 0 35px 0;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/slider.vue